import api from "./index";

export async function deposit(body) {
  return api.post("/payments", body);
}

export async function getPayment(paymentID) {
  return api.get(`/payments/${paymentID}`);
}
